/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import { loadFonts } from './webfontloader';
import vuetify from './vuetify';
import router from '../router';
import pinia from '../store';

// Types
import type { App } from 'vue';


export function registerPlugins(app: App) {
  loadFonts();
  app
    .use(vuetify)
    .use(pinia) // Use the Pinia store
    .use(router)
}
